customElements.define('component-header-promo-banner', class HeaderPromoBanner extends HTMLElement {
  constructor() {
    super();
  }

  connectedCallback() {
    // Properties
    this.sectionId = this.getAttribute('data-section-id');
    this.enabled = this.getAttribute('data-enabled') === 'true';
    this.autoplay = this.getAttribute('data-autoplay') === 'true';
    this.hidePlayButton = this.getAttribute('data-hide-play-icon') === 'true';
    this.playIcon = this.getAttribute('data-play-icon') || '';
    this.pauseIcon = this.getAttribute('data-pause-icon') || '';
    this.isSticky = this.getAttribute('data-sticky') === 'true' || false;
    this.stickyFrom = this.getAttribute('data-sticky-from');
    this.announcementDelay = Number(this.getAttribute('data-announcement-delay')) * 1000 || 5000;
    this.audience = window.Shopify.country === 'CA' ? 'ca' : 'us';
    this.config = window.promoBanner;
    this.isSmallDevice = window.innerWidth < window.theme.breakpoints.lg;
    this.localStorageUTMPrefix = 'tl_utm_';
    this.initPromoBar();
  }

  initPromoBar() {
    this.config.announcements.forEach((announcement) => {
      if (announcement.utm_parameter) {
        this.saveUTMParam(announcement?.utm_parameter);
      }
    });

    this.filteredAnnouncements = this.config.announcements.filter((text) => {
      if (!text.enabled) return false;
      if (this.isSmallDevice && !text.showInMobile) return false;
      if (!this.isSmallDevice && !text.showInDesktop) return false;
      if (text.utm_parameter && text.utm_parameter_value) return this.checkUTMParam(text.utm_parameter, text.utm_parameter_value)
      return !(text.audience !== 'all' && this.audience !== text.audience);
    });

    // Check for overrule announcement
    const overruleAnnouncement = this.filteredAnnouncements.find((msg) => msg.utm_parameter_overrule === true)
    this.filteredAnnouncements = overruleAnnouncement ? [overruleAnnouncement] : this.filteredAnnouncements;

    this.activeAnnouncementNumber = 0;
    this.activeAnnouncement = this.filteredAnnouncements[this.activeAnnouncementNumber];
    this.totalAnnouncements = this.filteredAnnouncements.length;
    this.isPlaying = this.autoplay;
    this.tooltipTitle = '';
    this.tooltipDescription = '';
    this.isModalOpened = false;
    this.progressBarPercentage = 0;

    // DOM elements
    this.bannerContainer = this.querySelector('.header-promo-banner-container');
    this.bannerContents = this.querySelector('.header-promo-banner-contents');
    this.prevButton = this.querySelector('.header-promo-banner__button--previous');
    this.playPauseButton = this.querySelector('.header-promo-banner__button--play-pause');
    this.nextButton = this.querySelector('.header-promo-banner__button--next');
    this.buttonWrapper = this.querySelector('.header-promo-banner__button-wrapper');
    this.progressBar = this.querySelector('.header-promo-banner__progress-bar');
    this.announcementContainer = this.querySelector('.header-promo-banner__announcement');
    this.announcementTextContainer = this.querySelector('.header-promo-banner__announcement--text');
    this.announcementLinkContainer = this.querySelector('.header-promo-banner__announcement--link');
    this.tooltipContainer = this.querySelector('.header-promo-banner__announcement--tooltip');
    this.modal = this.querySelector('.header-promo-banner__announcement--modal-wrapper');
    this.modalCloseButton = this.querySelector('.header-modal__close-button');
    this.modalTextContent = this.querySelector('.header-modal__text-description');
    this.modalTextTitle = this.querySelector('.header-modal__text-title');
    this.bannerContentsLink = this.querySelector('.header-promo-banner-contents-link');

    // Init
    if (this.filteredAnnouncements.length) {
      if (this.filteredAnnouncements.length === 1) {
        this.bannerContents.classList.add('justify-content-center');
      }
      this.bannerContents.classList.remove('hidden');
    }
    this.updateAnnouncement();
    if (this.isPlaying) {
      this.interval = this.startAutoPlay();
      this.progressInteval = this.initProgressBar();
    }
    if (this.isSticky) {
      this.bannerContainer.parentElement.parentElement.style.position = 'sticky';
      if (this.stickyFrom === 'top') {
        this.bannerContainer.parentElement.parentElement.style.top = '0';
      } else {
        this.bannerContainer.parentElement.parentElement.style.top = `${this.bannerContainer.getBoundingClientRect().top}`;
      }
    }
    if (this.totalAnnouncements > 1) {
      this.prevButton.classList.remove('hidden');
      this.nextButton.classList.remove('hidden');
      if (!this.hidePlayButton) {
        this.playPauseButton.classList.remove('hidden');
        this.progressBar.classList.remove('hidden');
      }
      this.buttonWrapper.classList.remove('hidden');
    } else {
      this.bannerContainer.style.justifyContent = 'center';
    }

    // Event handlers
    this.prevButton.addEventListener("click", () => {
      this.sendGTMData({ event: 'promo_bar_control_click', promo_bar_control: 'previous' });
      this.getActiveAnnouncement('previous');
      this.updateAnnouncement();
    });
    this.nextButton.addEventListener("click", () => {
      this.sendGTMData({ event: 'promo_bar_control_click', promo_bar_control: 'next' });
      this.getActiveAnnouncement('next');
      this.updateAnnouncement();
    });
    if (!this.hidePlayButton) {
      this.playPauseButton.addEventListener('click', () => {
        if (this.isPlaying) {
          this.resetProgressBar();
          clearInterval(this.progressInteval);
          clearInterval(this.interval);
        } else {
          this.interval = this.startAutoPlay();
          this.progressInteval = this.initProgressBar();
        }
        const newImage = this.isPlaying ? this.playIcon : this.pauseIcon;
        this.playPauseButton.innerHTML = `<img src=${newImage} alt='play and pause button'/>`;
        const buttonAction = this.isPlaying ? 'pause' : 'play';
        this.sendGTMData({ event: 'promo_bar_control_click', promo_bar_control: buttonAction });
        this.isPlaying = !this.isPlaying;
      });
    }
    this.announcementLinkContainer.addEventListener("click", () => this.trackClickGTM());
    this.tooltipContainer.addEventListener("click", () => this.handleTooltipClick());
  }

  disconnectedCallback() {
    clearInterval(this.interval);
    clearInterval(this.progressInteval);
  }

  startAutoPlay() {
    return setInterval(() => {
      this.getActiveAnnouncement('next')
      this.updateAnnouncement();
    }, this.announcementDelay);
  }

  initProgressBar() {
    if (this.hidePlayButton) {
      return;
    }
    return setInterval(() => {
      this.progressBarPercentage = this.progressBarPercentage + 2;
      this.progressBar.style.strokeDasharray = 62.83;
      this.progressBar.style.strokeDashoffset = 62.83 - ((62.83 * this.progressBarPercentage) / 100);
    }, this.announcementDelay / 50);
  }

  resetProgressBar() {
    if (this.hidePlayButton) {
      return
    }
    this.progressBarPercentage = 0;
    this.progressBar.style.strokeDashoffset = 0;
  }

  getActiveAnnouncement(nextOrPrevious) {
    if (nextOrPrevious === 'previous') {
      this.activeAnnouncementNumber = this.activeAnnouncementNumber === 0
        ? this.totalAnnouncements - 1 : this.activeAnnouncementNumber - 1;
      this.activeAnnouncement = this.filteredAnnouncements[this.activeAnnouncementNumber];
    } else {
      this.activeAnnouncementNumber = this.activeAnnouncementNumber === (this.totalAnnouncements - 1)
        ? 0 : this.activeAnnouncementNumber + 1;
      this.activeAnnouncement = this.filteredAnnouncements[this.activeAnnouncementNumber];
    }
  }

  updateAnnouncement() {
    const shouldShowTooltip = this.activeAnnouncement?.tooltip
      && this.activeAnnouncement?.tooltip.enabled
      && !!this.activeAnnouncement?.tooltip.title
      && !!this.activeAnnouncement?.tooltip.description;

    this.activeAnnouncement.linkUrl = `${this.activeAnnouncement?.linkUrl}`;
    this.announcementTextContainer.innerHTML = this.activeAnnouncement?.text;

    if (this.activeAnnouncement?.linkText && this.activeAnnouncement.linkText.trim().length > 0) {
      this.announcementLinkContainer.innerHTML =
        `<a href=${this.activeAnnouncement?.linkUrl} style="color: ${this.activeAnnouncement?.linkColor}; text-decoration: underline;">
          ${this.activeAnnouncement?.linkText}
        </a>`;
      this.announcementLinkContainer.style.display = '';
    } else {
      this.announcementLinkContainer.innerHTML = '';
      this.announcementLinkContainer.style.display = 'none';
    }

    // Update font size
    this.announcementTextContainer.style.fontSize = this.activeAnnouncement?.fontSizeDesktop || '16px';
    if (this.isSmallDevice) {
      this.announcementTextContainer.style.fontSize = this.activeAnnouncement?.fontSizeMobile || '16px';
    }

    this.announcementLinkContainer.style.fontSize = this.activeAnnouncement?.fontSizeDesktop || '16px';
    if (this.isSmallDevice) {
      this.announcementLinkContainer.style.fontSize = this.activeAnnouncement?.fontSizeMobile || '16px';
    }

    // Update item link
    if(this.bannerContentsLink){
      if (this.activeAnnouncement?.announcementBarClickableEnabled && this.activeAnnouncement?.announcementBarClickableUrl) {
        this.bannerContentsLink.style.cursor = 'pointer';
        this.bannerContentsLink.setAttribute('href', this.activeAnnouncement?.announcementBarClickableUrl);
      } else { 
        this.bannerContentsLink.style.cursor = 'default';
        this.bannerContentsLink.removeAttribute('href');
      }
    }

    this.announcementContainer.style.color = this.activeAnnouncement?.textColor;
    this.bannerContainer.style.backgroundColor = this.activeAnnouncement?.backgroundColor;
    this.nextButton.style.stroke = this.activeAnnouncement?.textColor;
    this.prevButton.style.stroke = this.activeAnnouncement?.textColor;
    if (shouldShowTooltip) {
      this.tooltipContainer.style.display = 'inline-block';
      this.tooltipTitle = this.activeAnnouncement?.tooltip.title || 'This looks strange';
      this.tooltipDescription = this.activeAnnouncement?.tooltip.description || 'Oops! Seems like something went wrong';
      this.tooltipContainer.style.setProperty('--tooltip-background-color', this.activeAnnouncement?.tooltip.backgroundColor);
      this.tooltipContainer.style.setProperty('--tooltip-icon-color', this.activeAnnouncement?.tooltip.iconColor);
    } else {
      this.tooltipContainer.style.display = 'none';
    }
    this.resetProgressBar();
  }

  handleTooltipClick() {
    this.sendGTMData({ event: 'tooltip_click', promo_bar_control: 'open_modal' });
    this.modalCloseButton.addEventListener('click', () => this.closeModal(), { once: true });
    window.addEventListener('keydown', (event) => this.handleEsc(event), { once: true });
    this.modalTextContent.innerHTML = this.tooltipDescription;
    this.modalTextTitle.innerHTML = this.tooltipTitle;
    this.modal.style.display = 'block';
    this.isModalOpened = true;
    document.body.classList.add('overflow-hidden');
  }

  handleEsc(event) {
    const ESC_KEY = 27;
    if (event.keyCode === ESC_KEY) {
      this.closeModal();
    }
  };

  closeModal() {
    this.modal.style.display = 'none';
    this.isModalOpened = false;
    document.body.classList.remove('overflow-hidden');
  }

  trackClickGTM() {
    const trackingData = {
      event: 'promo_bar_click',
      promo_bar_background_color: this.activeAnnouncement?.backgroundColor || '',
      promo_bar_font_size: '16px',
      promo_bar_text: this.activeAnnouncement?.text || '',
      promo_bar_text_color: this.activeAnnouncement?.textColor || '',
      promo_bar_link_text: this.activeAnnouncement?.linkText || '',
      promo_bar_link_color: this.activeAnnouncement?.linkColor || '',
      promo_bar_link_url: this.activeAnnouncement?.linkUrl || '',
      promo_bar_width: `${window.innerWidth}px`,
      promo_bar_height: '42px',
    };
    this.sendGTMData(trackingData);
  }

  sendGTMData(data) {
    window.sendGTMData && window.sendGTMData(data);
  }

  saveUTMParam(param) {
    if (param) {
      const urlParams = new URLSearchParams(window.location.search);
      const filterParam = urlParams.get(param);
      if (filterParam) {
        sessionStorage.setItem(`${this.localStorageUTMPrefix}${param}`, filterParam);
      }
    }
  }

  checkUTMParam(param, value) {
    const storedUTMParam = sessionStorage.getItem(`${this.localStorageUTMPrefix}${param}`);
    return storedUTMParam === value;
  }
});
